(function () {
  'use strict';
  var requestNumber = 0;
  function refreshCount() {
    var number = ++requestNumber;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        if (number !== requestNumber || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
        document.querySelectorAll('[data-nbf-cart-count]').forEach(function (node) {
          node.textContent = String(cart.item_count);
        });
      })
      .catch(function () { /* Preserve the last confirmed count on network errors. */ });
  }
  function initialize() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
    }
    document.addEventListener('cart:updated', refreshCount);
    // Shrine CartItems.updateQuantity dispatches this in finally, even if rendering skips pubsub.
    document.addEventListener('cartQuantityUpdated', refreshCount);
    window.addEventListener('pageshow', refreshCount);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refreshCount();
    });
    refreshCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
